"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
/**
 * @deprecated use {@link WCAGRadioButton} instead
 */
class RadioButtonWrapper extends InputWidget_1.default {
    constructor(element) {
        super(element);
        if (!(element instanceof HTMLInputElement) || element.type !== "radio") {
            throw new Error(`Unable to wrap: ${element}, since it's not a radio button`);
        }
    }
    parseValueFromInput() {
        return this.getInput().checked;
    }
    decorateElement(element) {
        element.type = "radio";
    }
    setValueOnInput(value, input) {
        this.getInput().checked = value;
    }
}
exports.default = RadioButtonWrapper;
//# sourceMappingURL=RadioButtonWrapper.js.map